import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { currencySymbol } from "../PriceWithCurrency";

const FETCH_PRODUCT_WITH_BOM_COST_HISTORY = gql`
  query FETCH_PRODUCT_WITH_BOM_COST_HISTORY(
    $id: ID!
    $company: String!
    $currency: String!
  ) {
    product(id: $id) {
      id
      defaultQty
      productWithBomCostHistory(company: $company, currency: $currency)
    }
  }
`;

const ProductWithBomCostHistoryView = ({ id, company, currency }) => {
  const { loading, error, data } = useQuery(
    FETCH_PRODUCT_WITH_BOM_COST_HISTORY,
    { variables: { id, company, currency } },
  );

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const res = JSON.parse(data.product.productWithBomCostHistory);

  console.log("ProductWithBomCostHistoryView", res);

  if (!res.length)
    return (
      <div>
        This product does not have any cost history, it has only the latest
        cost.
      </div>
    );

  const products = Object.keys(res[0]).filter(
    (key) => key !== "date" && key !== "cost",
  );

  console.log("products", products);

  return (
    <div>
      <div className="text-sm">
        Below shows the cost history of the product with BOM. The cost is
        calculated based on the BOM cost and the default quantity of the
        product, which is {data.product.defaultQty}. <br />
        Note that this history is using the latest exchange rate. This means the
        cost may not match the actual cost at the time of the order, as the
        exchange rate may have changed since then.
      </div>
      <div className="card px-4 py-2 mt-4 text-xs font-code">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              {products.map((product) => (
                <th className="text-right" key={product}>
                  {product}
                </th>
              ))}
              <th className="text-right">Cost</th>
            </tr>
          </thead>
          <tbody>
            {res.map((item, index) => (
              <tr
                key={index}
                className="border-y dark:border-gray-700 border-gray-100"
              >
                <td className="whitespace-nowrap">{item.date}</td>
                {products.map((product) => (
                  <td className="text-right" key={product}>
                    {item[product].toFixed(3)}
                  </td>
                ))}
                <td className="text-right font-bold">
                  {currencySymbol(currency)}
                  {item.cost.toFixed(3)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductWithBomCostHistoryView;
